import
{
  getAuthenticationToken,
  getName,
  hasRole,
  isImpersonating,
  setAuthenticationToken
} from '@/functions/authentication-functions';
import { computed, defineComponent } from '@vue/composition-api';
import { Accounts } from "@noordigitalagency/accounts-ledigajobb";
import { SettingsContext } from "@/utilities/settings-context";

export default defineComponent({
  setup()
  {

    const isAdmin = computed(() => hasRole('Administrator'));

    const isModerator = computed(() => isAdmin.value || hasRole('Moderator'));

    const isEconomy = computed(() => isAdmin.value || hasRole('Economy'));

    const isContentWriter = computed(() => isAdmin.value || hasRole('ContentWriter'));

    const isInternalSales = computed(() => isAdmin.value || hasRole('InternalSales'));

    const impersonating = computed(() => isImpersonating());

    const impersonated = computed(() => impersonating ? getName() : '');

    const stopImpersonating = async () =>
    {
      const accounts = new Accounts(SettingsContext.constants.accountsApiDomainName, getAuthenticationToken());

      setAuthenticationToken(await accounts.unImpersonate());

      location.pathname = '/';
    };

    return {
      isModerator,
      isAdmin,
      isEconomy,
      impersonating,
      impersonated,
      isContentWriter,
      isInternalSales,
      stopImpersonating
    }
  }
})